export default "__VITE_ASSET__Cs_f$JnB__"